import { render, staticRenderFns } from "./Internal_Support.vue?vue&type=template&id=7a5d2a46&scoped=true"
import script from "./Internal_Support.vue?vue&type=script&lang=js"
export * from "./Internal_Support.vue?vue&type=script&lang=js"
import style0 from "./Internal_Support.vue?vue&type=style&index=0&id=7a5d2a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d2a46",
  null
  
)

export default component.exports